import React from 'react'

export default function Navbar(props) {
    return (
        <div>

            <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}>
            <div className="container-fluid">
                <a className="navbar-brand" href="/index.html" >{props.title}</a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="/navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <a className="nav-link active" aria-current="page"     >About eSKIMo</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="/index.html"    >GitHub</a>
                        </li>
                        <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle"  href="/index.html"    id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                About Me
                            </a>
                            <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                <li><a className="dropdown-item"  href="/index.html"   >My Portfolio</a></li>
                                <li><a className="dropdown-item"   href="/index.html"  >LinkedIN</a></li>
                                <li><hr className="dropdown-divider" /></li>
                                <li><a className="dropdown-item"  href="/index.html"   >Twitter</a></li>
                            </ul>
                        </li>
                        {/* <li className="nav-item">
          <a className="nav-link disabled">Disabled</a>
        </li> */}
                    </ul>
                    <form className="d-flex">
                        {/* <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
                        <button className="btn btn-outline-success" type="submit">Search</button> */}
                        <div class={`form-check form-switch text-${props.mode=== 'light'? 'Dark' : 'light'}`}>
                            <input class="form-check-input" onClick={props.toggleMode}type="checkbox" role="switch" id="flexSwitchCheckDefault"/>
                                <label class="form-check-label" for="flexSwitchCheckDefault">Dark Mode🌙</label>
                        </div>
                    </form>
                </div>
            </div>
        </nav>
        </div >
    )
}
